import * as T from "@shared/types";
import { AllParamsConfig, ConfigAction, ConfigState } from "./types";
import {
  DEFAULT_PRODUCT_DESCRIPTION_MAX_LENGTH,
  DEFAULT_ROASTER_NOTE_MAX_LENGTH,
  DEFAULT_TITLE_MAX_LENGTH,
} from "@client-shared/lib/constants";

export const initialState: ConfigState = {
  initialized: false,
  loading: false,
  error: undefined,
  config: {
    localisedProductConfigByLocale: undefined,
    selectedLocalisedProductConfig: undefined,
    defaultRegionLocalisedProductConfig: undefined,
    productConfig: undefined,
    allBagSizesConfig: undefined,
    allGrindTypesConfig: undefined,
    inventoryConfig: undefined,
    multipleBagConfig: undefined,
    actionsConfig: undefined,
    marginConfig: undefined,
    isMultipleBagEnabled: true,
    regionLargeBagSize: undefined,
    roasterNoteMaxLength: DEFAULT_ROASTER_NOTE_MAX_LENGTH,
    productDescriptionMaxLength: DEFAULT_PRODUCT_DESCRIPTION_MAX_LENGTH,
    titleMaxLength: DEFAULT_TITLE_MAX_LENGTH,
    sltCustomerAccountNumber: undefined,
  },
};

export function setInitialized(initialized: boolean): ConfigAction {
  return {
    type: "SET_INITIALIZED",
    payload: {
      initialized,
    },
  };
}

export function setSelectedLocalisedProductConfig(selectedLocalisedProductConfig: T.LocalisedProductConfig | undefined): ConfigAction {
  return {
    type: "SET_SELECTED_LOCALISED_PRODUCT_CONFIG",
    payload: {
      selectedLocalisedProductConfig,
    },
  };
}

export function setDefaultRegionLocalisedProductConfig(
  defaultRegionLocalisedProductConfig: T.LocalisedProductConfig | undefined
): ConfigAction {
  return {
    type: "SET_DEFAULT_REGION_LOCALISED_PRODUCT_CONFIG",
    payload: {
      defaultRegionLocalisedProductConfig,
    },
  };
}

export function setAllParamConfig(allParamsConfig: AllParamsConfig): ConfigAction {
  return {
    type: "SET_ALL_PARAMETER_CONFIG",
    payload: allParamsConfig,
  };
}

export function setIsMultipleBagEnabled(isMultiBagEnabled: boolean): ConfigAction {
  return {
    type: "SET_IS_MULTI_BAG_ENABLED",
    payload: {
      isMultipleBagEnabled: isMultiBagEnabled,
    },
  };
}

export function setPimProductCategories(productCategories: T.PimProductsCategories[] | undefined): ConfigAction {
  return {
    type: "SET_PIM_PRODUCT_CATEGORIES",
    payload: {
      productCategories,
    },
  };
}

export function setLocalisedProductConfigByLocale(localisedProductConfigByLocale: T.LocaleWithLocalisedProductConfig): ConfigAction {
  return {
    type: "SET_LOCALISED_PRODUCT_CONFIG_BY_LOCALE",
    payload: {
      localisedProductConfigByLocale,
    },
  };
}

export function setLoading(loading: boolean): ConfigAction {
  return {
    type: "SET_LOADING",
    payload: {
      loading,
    },
  };
}

export function setProductConfig(productConfig: T.ProductConfig): ConfigAction {
  return {
    type: "SET_PRODUCT_CONFIG",
    payload: {
      productConfig,
    },
  };
}

export function setRegionLargeBagSize(regionLargeBagSize: string[] | undefined): ConfigAction {
  return {
    type: "SET_REGION_LARGE_BAG_SIZE",
    payload: {
      regionLargeBagSize,
    },
  };
}

export function reducer(state: ConfigState, action: ConfigAction): ConfigState {
  switch (action.type) {
    case "SET_INITIALIZED":
      return {
        ...state,
        initialized: true,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };

    case "SET_REGION_LARGE_BAG_SIZE":
      return {
        ...state,
        config: {
          ...state.config,
          regionLargeBagSize: action.payload.regionLargeBagSize,
        },
      };
    case "SET_PRODUCT_CONFIG":
      return {
        ...state,
        config: {
          ...state.config,
          productConfig: action.payload.productConfig,
        },
      };
    case "SET_LOCALISED_PRODUCT_CONFIG_BY_LOCALE":
      return {
        ...state,
        config: {
          ...state.config,
          localisedProductConfigByLocale: action.payload.localisedProductConfigByLocale,
        },
      };

    case "SET_SELECTED_LOCALISED_PRODUCT_CONFIG":
      return {
        ...state,
        config: {
          ...state.config,
          selectedLocalisedProductConfig: action.payload.selectedLocalisedProductConfig,
        },
      };

    case "SET_DEFAULT_REGION_LOCALISED_PRODUCT_CONFIG":
      return {
        ...state,
        config: {
          ...state.config,
          defaultRegionLocalisedProductConfig: action.payload.defaultRegionLocalisedProductConfig,
        },
      };
    case "SET_IS_MULTI_BAG_ENABLED":
      return {
        ...state,
        config: {
          ...state.config,
          isMultipleBagEnabled: action.payload.isMultipleBagEnabled,
        },
      };
    case "SET_ALL_PARAMETER_CONFIG":
      return {
        ...state,
        config: {
          ...state.config,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
